import {
  useContext, useMemo
} from 'react'
import DOMPurify from 'isomorphic-dompurify'
import { useSubtitles } from '../lib/playerHooks'
import { CaptionsContext } from '../context/CaptionsContext'

export const LiveCaptionsPresentation: React.FC<Record<string, never>> = () => {
  const subtitle = useSubtitles()
  const { captionSize } = useContext(CaptionsContext)

  const sanitizedBrokenLines = useMemo(() => {
    // Memoized to prevent recomputing this every progress update
    // Looks for <br/> <br> &lt; &gt; \n
    // handles whitespace in break tags
    const findLineBreaks = /<\s*br\s*\/?\s*>|&lt;?\s*br\s*\/?\s*&gt;?|\\n/
    const lines = subtitle.split(findLineBreaks)
    // remove empty lines
    lines.forEach((line, index) => {
      if (line.length === 0) lines.splice(index)
    })
    const brokenLines = lines.map((line) => `${line} <br />`).join('')
    return DOMPurify.sanitize(brokenLines)
  }, [subtitle])

  return (
    <div
      style={{ fontSize: `${captionSize}em` }}
      className="captions-text"
      dangerouslySetInnerHTML={{ __html: sanitizedBrokenLines }}
    />
  )
}

export default LiveCaptionsPresentation
